import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear(); // Get current year

  return (
    <footer className="pb-30 pt-30">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <p className="fz-13">
                © {currentYear} Praveen Dubbaka 
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
